import {PostContainer} from "./News.styles";
import React, {useEffect, useState} from "react";
import SectionTitle from "../../components/section-items/SectionTitle/SectionTitle";
import SectionText from "../../components/section-items/SectionText/SectionText";
import SectionContainer from "../../components/section-items/SectionContainer/SectionContainer";
import SectionButton from "../../components/section-items/SectionButton/SectionButton";
import Post from "./Post/Post";
import Section from "../../components/section-items/Section/Section";
import {fetchLatest} from "../../helpers/fetchData";
import LoadingSpinner from "../../components/spinners/LoadingSpinner";

const News = () => {

    const [posts, setPosts] = useState([]);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        fetchLatest('posts')
            .then((res) => setPosts(res))
            .then(() => setIsFetching(false))
            .catch((e) => console.error(e));
    }, []);

    const renderPosts = () => {
        return posts?.map((e, index) =>
            <Post id={e.id} images={e.images} key={e.date + index} image={e.images[0]} title={e.title} date={e.date} text={e.text}/>
        );
    };

    return (<Section theme={'dark'}>
        <SectionContainer style={{flex: 1}}>
            <SectionTitle color={'white'}>{'AKTUALNOŚCI'}</SectionTitle>
            <SectionText
                color={'white'}>{'Śledź aktualności by być na bieżąco z działalnością naszej drużyny. Pojawiają się tam zapowiedzi meczów, wyniki, szczegółowe relacje, a także wszelkie istotne wydarzenia związane z naszym klubem. Cenimy sobie szybkie i rzetelne informowanie naszych kibiców i sympatyków.'}</SectionText>
            <SectionButton text={'PRZEJDŹ DO SEKCJI AKTUALNOŚCI'}
                           section={'news'}
                           backgroundColor={'#1F1F1F'}
                           style={{marginTop: 30}}
            />
        </SectionContainer>
        <PostContainer>{ isFetching ? <LoadingSpinner color={'white'}/> : renderPosts() }</PostContainer>
    </Section>);
};

export default News;
